import AnchoredVolumeProfileIcon from '../../../../assets/icons/drawingTools/anchoredVolumeProfile'
import DateRangeIcon from '../../../../assets/icons/drawingTools/dateRange'
import FixedRangeVolumeProfileIcon from '../../../../assets/icons/drawingTools/fixedRangeVolumeProfile'
import ForecastIcon from '../../../../assets/icons/drawingTools/forecast'
import LongPositionForecastIcon from '../../../../assets/icons/drawingTools/longPositionForecast'
import PriceRangeIcon from '../../../../assets/icons/drawingTools/priceRange'
import ShortPositionForecastIcon from '../../../../assets/icons/drawingTools/shortPositionForecast'
import { DrawingToolMenuItem } from './drawingToolMenu'

export const forecastToolMenuItems: DrawingToolMenuItem[] = [
    {
        drawingToolId: 'positionForecast',
        text: 'Long Position',
        icon: <LongPositionForecastIcon />,
        drawingType: 'positionForecast',
        toolOptions: {
            longPosition: true
        }
    },
    {
        drawingToolId: 'positionForecast',
        text: 'Short Position',
        icon: <ShortPositionForecastIcon />,
        drawingType: 'positionForecast',
        toolOptions: {
            longPosition: false
        }
    },
    {
        drawingToolId: 'dateRange',
        text: 'Date Range',
        icon: <DateRangeIcon />,
        drawingType: 'dateRange',
        toolOptions: {}
    },
    {
        drawingToolId: 'priceRange',
        text: 'Price Range',
        icon: <PriceRangeIcon />,
        drawingType: 'priceRange',
        toolOptions: {}
    },
    {
        drawingToolId: 'forecast',
        text: 'Forecast',
        icon: <ForecastIcon />,
        toolOptions: {},
        drawingType: 'forecast'
    },
    {
        drawingToolId: 'fixedRangeVolumeProfile',
        text: 'Fixed Range Volume Profile',
        icon: <FixedRangeVolumeProfileIcon />,
        toolOptions: {},
        drawingType: 'fixedRangeVolumeProfile'
    },
    {
        drawingToolId: 'anchoredVolumeProfile',
        text: 'Anchored Volume Profile',
        icon: <AnchoredVolumeProfileIcon />,
        toolOptions: {},
        drawingType: 'anchoredVolumeProfile'
    }
]